import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export type TrainModelTimeEstimateBodyType = { model_versions: Array<Partial<CF.API.Models.Model>>; estimated_input_count: number };

interface timeEstimateResponse {
  training_time_estimates: string[];
}

type Response = CF.API.Status & timeEstimateResponse;

export const trainModelTimeEstimateTE = <E = CF.API.ApiError>(
  { userOrOrgId, appId, modelId, body }: { userOrOrgId: string; appId: string; modelId: string; body: TrainModelTimeEstimateBodyType },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, Response> =>
  fetchTE<Response, E>(
    {
      path: `/api/_api/v2/users/${userOrOrgId}/apps/${appId}/models/${modelId}/versions/time_estimate`,
      method: 'POST',
      body,
    },
    onRejected,
  );
